/**
 * name : Application
 * desc : area three level
 * at : Created by HW with WebStorm on 2018/7/13 13:51.
 * uri :
 */

import CtAreas from './Areas';

CtAreas.install = Vue => Vue.component(CtAreas.name, CtAreas);

export default CtAreas;



// WEBPACK FOOTER //
// ./src/views/area/index.js